import { Theme } from '@material-ui/core/';

const styles = (theme: Theme) =>
  ({
    title: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingTop: 16,
      paddingBottom: 16,
    },
    imgContact: {
      width: 400,
    },
    iconImportant: {
      marginRight: 8,
      minWidth: 16,
      '& g': {
        fill: theme.palette.secondary.main,
      },
    },
    contactSaga: {
      '& a': {
        color: theme.palette.secondary.main,
      },
      '& > p': {
        display: 'flex',
        alignItems: 'flex-start',
        '& > svg': {
          marginRight: 8,
          marginBottom: 6,
          width: 20,
          fill: theme.palette.secondary.main,
        },
        '& strong, & a': {
          marginLeft: 4,
        },
        '& > span': {
          marginLeft: 4,
        },
      },
    },
    legend: {
      color: theme.palette.primary.dark,
    },
    listSaga: {
      listStyle: 'none',
      '& li': {
        display: 'flex',
        alignItems: 'flex-start',
      },
      '& li::before': {
        content: '" "',
        width: '6px',
        minWidth: '6px',
        marginRight: '8px',
        marginTop: '8px',
        borderRadius: '100%',
        height: '6px',
        background: theme.palette.secondary.main,
        display: 'block',
      },
    },
    '@media all and (max-width: 500px)': {
      imgContact: {
        width: 300,
      },
    },
  } as any);

export default styles;
